import React from "react";
import PropTypes from "prop-types";
import { Row, Spin, Icon } from "antd";
import { get } from "lodash";
import { Lib, CheckPermission } from "App/Utils";
import SubAllList from "App/Component/SubAllList";
import descriptor from "./descriptorOffline";

class PagePmHardwareStartingRange extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isGettingPermissions: true,
      permissionItems: [],
    }
  }

  getPermissions = () => {
    const permissionItems = CheckPermission.getPermissionSet({
      userReducer: this.props.userReducer,
      appName: 'estimation',
      modelName: 'pmhardwarestartingrange',
    }).filter(perm => !perm.includes('.delete_'))
    this.setState({ isGettingPermissions: false, permissionItems })
  }

  onAddPmHardware = () => {
    const { merchant } = this.props
    const historyState = {
      dataIdentifier: {
        merchant: { pk: merchant.pk, name: merchant.name }
      }
    }
    Lib.historyAction(this.props.history, '/admin/estimation/pm-hardware-starting-ranges/add', historyState).push()
  }

  onDetailPmHardware = (id) => {
    Lib.historyAction(this.props.history, `/admin/estimation/pm-hardware-starting-ranges/${id}`).push()
  }

  componentDidMount() {
    this.getPermissions()
  }

  componentWillUnmount() {
    Lib.windowStop();
  }

  render() {
    const { userReducer, match } = this.props
    const { isGettingPermissions, permissionItems } = this.state

    return isGettingPermissions ? (
      <Row type='flex' justify='center' align='middle' style={{ margin: '30vh 0' }}>
        <Spin
          size='large'
          tip='Loading...'
          indicator={<Icon spin type='loading' style={{ fontSize: '4rem' }} />}
        />
      </Row>
    ) : (
      <SubAllList
        permissions={permissionItems}
        pageTitle="PM Hardware Starting Range"
        avatar="subheading.label"
        descriptor={descriptor}
        masterKey="module-merchant-merchant-refPmHardware"
        args={[get(match, 'params.id')]}
        onAddClick={this.onAddPmHardware}
        onDetailClick={this.onDetailPmHardware}
        userReducer={userReducer}
      />
    );
  }
}

PagePmHardwareStartingRange.propTypes = {
  userReducer: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  merchant: PropTypes.object.isRequired,
}

PagePmHardwareStartingRange.defaultProps = {
  permissionItems: [],
}

export default PagePmHardwareStartingRange;
